module.exports = __webpack_public_path__ + "img/vr-2.0ed800fc.png";